import React, { useState, useEffect } from "react";
import { TextField, FormHelperText, Box, Typography } from "@mui/material";

const ExperienceInput = ({ value, onChange }) => {
  const [experienceText, setExperienceText] = useState("");
  const [experienceEmoji, setExperienceEmoji] = useState("");

  useEffect(() => {
    if (value !== undefined) {
      getExperiences(value);
    }
  }, [value]);

  const getExperiences = (months) => {
    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;
    let experienceString = "";
    let emoji = "";

    if (years > 0) {
      experienceString += `${years} ${years > 1 ? "years" : "year"}`;
      emoji = years >= 5 ? "🌟" : years >= 2 ? "🔥" : "👍";``
    }
    if (remainingMonths > 0) {
      experienceString += ` ${remainingMonths} ${
        remainingMonths > 1 ? "months" : "month"
      }`;
      if (years === 0) {
        emoji = remainingMonths >= 6 ? "✨" : "😊";
      }
    }
    if (months === 0) {
      emoji = "🎓";
      experienceString = "Fresher / Intern / Trainee";
    }

    setExperienceText(experienceString.trim());
    setExperienceEmoji(emoji);
  };

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TextField
        label="Experience (in months)"
        type="number"
        value={value}
        onChange={(e) => {
          const newValue = Math.min(492, Math.max(0, Number(e.target.value)));
          onChange(newValue);
        }}
        InputProps={{ inputProps: { min: 0, max: 492, step: 1 } }}
        variant="outlined"
        // sx={{ width: "100%", minWidth: "200px" }}
        sx={{
          width: "100%",
          minWidth: "200px",
          "& .MuiInputLabel-root": { color: "#000" },  // Label black
          // "& .MuiInputLabel-root.Mui-focused": { color: "#000" }, // Focus label black
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#8c8c8cff;" }, // Border black
          },
          input: { color: "#000" }, // Text black
        }}
        fullWidth
      />
      <FormHelperText
        sx={{ fontSize: "1rem", fontWeight: "bold", color: "#4caf50" }}
      >
        {experienceEmoji} {experienceText}
      </FormHelperText>
    </Box>
  );
};

export default ExperienceInput;
